// extracted by mini-css-extract-plugin
module.exports = {"box":"BlendBox_box__2xb8c","selected":"BlendBox_selected__3bGUP","clickable":"BlendBox_clickable__260cc"};